import { render, staticRenderFns } from "./verite-vigneron.vue?vue&type=template&id=93c73e5a&scoped=true"
import script from "./verite-vigneron.vue?vue&type=script&lang=js"
export * from "./verite-vigneron.vue?vue&type=script&lang=js"
import style0 from "./verite-vigneron.vue?vue&type=style&index=0&id=93c73e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c73e5a",
  null
  
)

export default component.exports